import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { socket } from "../../App";
import { setShareData } from "../../redux/slices/tempSlice";
import axios from "../Hooks/axios";
import styles from "./SharePopup.module.scss";
import DefaultProfilePic from "../../assets/images/user.png";

const SharePopup = () => {
	const baseUrl = window.location.origin;
	const {
		share: { endPoint, id },
	} = useSelector((state) => state.temp);
	const dispatch = useDispatch();
	const [shareLink, setShareLink] = useState(`${endPoint}${id}`);
	const [followingUsers, setFollowingUsers] = useState([]);
	const {userId, user } = useSelector((state) => state.auth);

	const handleCopyClick = () => {
		navigator.clipboard
			.writeText(baseUrl + shareLink)
			.then(() => {
				toast.success("Copied to clipboard!");
			})
			.catch((err) => {
				toast.error("Copy failed");
			});
	};

	useEffect(() => {
		axios
			.get("/auth/follower-following")
			.then(({ data }) => {
				setFollowingUsers(data.data.followingData);
			})
			.catch((e) => console.log(e));
	}, []);

	const shareOnWhatsApp = () => {
		const whatsappURL = `whatsapp://send?text=${encodeURIComponent(
			`Check out this ${endPoint === "/Post/" ? "post" : "story"}: ${baseUrl+shareLink}`
		)}`;
		window.location.href = whatsappURL;
	};

	const handelShare = (id) => {
		let sd = {
			notification_from: userId,
			notification_to: id,
			notification: {
				link: shareLink,
			},
			title: `${endPoint === "/Post/" ? "Post" : "Story"} Shared`,
			message: `${user.username} share a ${endPoint === "/Post/" ? "post" : "story"} with you`,
		};
		socket.emit("notification", sd);
		toast.success("Share Successfully");
	};

	return (
		<div className={styles.SharePopupWrapper} onClick={() => dispatch(setShareData({ show: false, endPoint: "", id: "" }))}>
			<div className={styles.SharePopup} onClick={(e) => e.stopPropagation()}>
				<div className={styles.Top}>
					<input type="text" readOnly value={baseUrl + shareLink} />
					<button onClick={handleCopyClick}>
						<svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43" fill="none">
							<path
								d="M31.5261 26.4478L29.0596 23.9816L31.5261 21.5153C34.2503 18.7911 34.2503 14.3743 31.5261 11.6502C28.8019 8.92595 24.385 8.92595 21.6608 11.6502L19.1946 14.1164L16.7283 11.6502L19.1946 9.18386C23.2808 5.09757 29.906 5.09757 33.9924 9.18386C38.0786 13.2701 38.0786 19.8954 33.9924 23.9816L31.5261 26.4478ZM26.5934 31.3806L24.1271 33.8468C20.0409 37.933 13.4157 37.933 9.32936 33.8468C5.24308 29.7604 5.24308 23.1352 9.32936 19.049L11.7957 16.5827L14.262 19.049L11.7957 21.5153C9.07147 24.2395 9.07147 28.6564 11.7957 31.3806C14.5199 34.1048 18.9366 34.1048 21.6608 31.3806L24.1271 28.9143L26.5934 31.3806ZM26.5934 14.1164L29.0596 16.5827L16.7283 28.9143L14.262 26.4478L26.5934 14.1164Z"
								fill="white"
							/>
						</svg>
					</button>
				</div>

				<div className={styles.Middle}>
					<div className={styles.ButtonWrapper}>
						<button onClick={shareOnWhatsApp}>
							<svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43" fill="none">
								<path
									d="M13.3956 33.1811L14.6595 33.9181C16.7709 35.1494 19.1706 35.8068 21.6747 35.8068C29.3799 35.8068 35.6262 29.5606 35.6262 21.8553C35.6262 14.1502 29.3799 7.90388 21.6747 7.90388C13.9695 7.90388 7.72322 14.1502 7.72322 21.8553C7.72322 24.3602 8.38108 26.7607 9.61308 28.8726L10.3497 30.1352L9.21004 34.3234L13.3956 33.1811ZM4.24264 39.2947L6.60037 30.6299C5.09679 28.0526 4.23535 25.0546 4.23535 21.8553C4.23535 12.2239 12.0432 4.41602 21.6747 4.41602C31.3061 4.41602 39.114 12.2239 39.114 21.8553C39.114 31.4867 31.3061 39.2947 21.6747 39.2947C18.4765 39.2947 15.4794 38.4339 12.9025 36.9311L4.24264 39.2947ZM15.3814 13.6734C15.6149 13.657 15.8492 13.6545 16.083 13.6659C16.1774 13.6721 16.2714 13.683 16.3655 13.6939C16.6432 13.7259 16.9486 13.8951 17.0513 14.1279C17.5716 15.3075 18.0764 16.4939 18.5656 17.6867C18.6736 17.95 18.6085 18.2913 18.4031 18.6216C18.2988 18.7909 18.135 19.0284 17.9453 19.2714C17.7481 19.5237 17.3236 19.9878 17.3236 19.9878C17.3236 19.9878 17.1516 20.1939 17.2164 20.4504C17.2417 20.5474 17.3222 20.6887 17.3952 20.8074C17.4357 20.8732 17.4732 20.9319 17.4976 20.9726C17.9439 21.7178 18.5438 22.4732 19.2766 23.1835C19.4866 23.387 19.6903 23.5947 19.9093 23.7876C20.726 24.5077 21.65 25.0961 22.6478 25.5319L22.6567 25.5359C22.8041 25.5994 22.8798 25.6341 23.0955 25.7257C23.2043 25.7717 23.3156 25.8115 23.4298 25.8416C23.4711 25.8524 23.5135 25.8585 23.5561 25.8615C23.8381 25.8784 24.0011 25.6976 24.0707 25.6144C25.3324 24.0858 25.4479 23.9861 25.4566 23.9868V23.9896C25.6225 23.8148 25.8832 23.7541 26.1158 23.7684C26.222 23.7749 26.3277 23.7953 26.4243 23.8394C27.3517 24.2625 28.8681 24.9224 28.8681 24.9224L29.8822 25.3783C30.052 25.4602 30.2071 25.6533 30.2146 25.8409C30.2191 25.9576 30.2317 26.1459 30.19 26.4905C30.1354 26.9417 29.9982 27.4849 29.8618 27.7696C29.7659 27.9692 29.6417 28.1464 29.4973 28.2964C29.3015 28.4997 29.156 28.6232 28.9206 28.7986C28.7772 28.9054 28.7029 28.9556 28.7029 28.9556C28.4607 29.1084 28.3242 29.1847 28.0355 29.3384C27.5867 29.5775 27.0907 29.7149 26.5827 29.7411C26.2588 29.7576 25.9358 29.781 25.6123 29.7636C25.598 29.7627 24.6214 29.6127 24.6214 29.6127C22.1417 28.9605 19.8485 27.7387 17.9241 26.0443C17.5307 25.6979 17.1658 25.3232 16.7933 24.9524C15.2429 23.4088 14.0691 21.7444 13.3574 20.17C13.0064 19.3936 12.7841 18.5621 12.7806 17.7065C12.7742 16.6481 13.1207 15.6176 13.7654 14.7782C13.8925 14.6127 14.0132 14.4411 14.2213 14.2446C14.4417 14.0364 14.582 13.9247 14.7331 13.8474C14.9345 13.7444 15.1558 13.6892 15.3814 13.6734Z"
									fill="white"
								/>
							</svg>
						</button>
						<p>What’s app</p>
					</div>
					{/* <div className={styles.ButtonWrapper}>
						<button className={styles.ThreeDot}>
							<svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43" fill="none">
								<path
									d="M8.92732 18.3691C7.00899 18.3691 5.43945 19.9387 5.43945 21.857C5.43945 23.7753 7.00899 25.3449 8.92732 25.3449C10.8456 25.3449 12.4152 23.7753 12.4152 21.857C12.4152 19.9387 10.8456 18.3691 8.92732 18.3691ZM33.3424 18.3691C31.4241 18.3691 29.8545 19.9387 29.8545 21.857C29.8545 23.7753 31.4241 25.3449 33.3424 25.3449C35.2607 25.3449 36.8302 23.7753 36.8302 21.857C36.8302 19.9387 35.2607 18.3691 33.3424 18.3691ZM21.1349 18.3691C19.2165 18.3691 17.647 19.9387 17.647 21.857C17.647 23.7753 19.2165 25.3449 21.1349 25.3449C23.0532 25.3449 24.6227 23.7753 24.6227 21.857C24.6227 19.9387 23.0532 18.3691 21.1349 18.3691Z"
									fill="white"
								/>
							</svg>
						</button>
						<p>Other App</p>
					</div> */}
				</div>

				<div className={styles.Bottom}>
					<p>Share with friends</p>
					<div className={styles.FollowWrapper}>
						{followingUsers.map((data, index) => (
							<div key={index} className={styles.Box}>
								<div className={styles.left}>
									<div className={styles.InnerLeft}>
										<img 
											src={data.ProfilePic || DefaultProfilePic} 
											alt="" 
											onError={(e) => { e.target.src = DefaultProfilePic; }}
										/>
									</div>
									<div className={styles.InnerRight}>
										<h2>{data.username}</h2>
										<h4>Following</h4>
									</div>
								</div>

								<button className={styles.right} onClick={() => handelShare(data?._id)}>
									Share
								</button>
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};

export default SharePopup;


